import { Helmet } from "react-helmet-async";

const SITE = "https://quickridegh.com";

export default function Seo({ title, description, path = "", image = "/hero.jpg" }) {
  const url = SITE + path;
  const img = image.startsWith("http") ? image : SITE + image;
  const full = title ? `${title} · Quick Ride` : "Quick Ride — Official GPRTU Bus Ticket Booking in Ghana";
  return (
    <Helmet>
      <title>{full}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={full} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta name="twitter:title" content={full} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
